import { observer } from 'mobx-react';
import { AdminEditModal } from '@code-yellow/spider';
import { Project } from '../../store/Project';
import { CompanyStore } from '../../store/Company';
import { TeamStore } from '../../store/Team';
import { UserStore } from '../../store/User';

@observer
export default class ProjectEditModal extends AdminEditModal {
    modalProps = { size: 'tiny' };

    Model = Project;

    // Include commentNoteThread so the modal's internal model has it in
    // __activeCurrentRelations — without this, toBackend() never serializes
    // comment_note_thread and the backend rejects with 400 "null not allowed".
    relations = ['company', 'team', 'projectLead', 'commentNoteThread'];

    companyStore = new CompanyStore();
    teamStore = new TeamStore();
    userStore = new UserStore();

    fields = [
        { type: 'text', name: 'name' },
        { type: 'bool', name: 'hidden' },
        () => ({
            type: 'select',
            name: 'company',
            remote: true,
            store: this.companyStore,
            toOption: (company: any) => ({ text: company.name, value: company.id }),
        }),
        () => ({
            type: 'select',
            name: 'team',
            remote: true,
            store: this.teamStore,
            toOption: (team: any) => ({ text: team.name, value: team.id }),
        }),
        () => ({
            type: 'select',
            name: 'projectLead',
            remote: true,
            store: this.userStore,
            toOption: (user: any) => ({ text: user.fullName, value: user.id }),
            clearable: true,
        }),
    ];
}
